class LazyVideo extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.video = window.BAO.Utils.getElement('video', { context: this })

    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(this.onEntry.bind(this), {
      threshold: 0,
    })
    // We need to observe the video element as the host element has display: contents on it. IntersectionObserver won't work on an element that is set to display: contents
    this.observer.observe(this.video)
  }

  get Play () {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <path fill="currentColor" d="M16.933 11.2a1 1 0 0 1 0 1.6l-9.333 7A1 1 0 0 1 6 19V5a1 1 0 0 1 1.6-.8z"/>
      </svg>
    `
  }

  get Pause () {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <rect width="5" height="16" x="5" y="4" fill="currentColor" rx="1"/>
        <rect width="5" height="16" x="14" y="4" fill="currentColor" rx="1"/>
      </svg>
    `
  }

  addPlayPauseButton () {
    if (this.button) return

    const role = this.dataset.role // 'desktop' or 'mobile'
    const wrapper = this.closest('[data-lazy-video-external-el="wrapper"]')
    const target = wrapper || this

    this.button = document.createElement('button')
    this.button.className = `btn-PlayPause${role ? ` btn-PlayPause-${role}` : ''}`
    this.button.setAttribute('aria-label', 'Play/Pause decorative video')

    target.appendChild(this.button)

    this.video.addEventListener('play', () => {
      this.button.innerHTML = this.Pause
    })
    this.video.addEventListener('pause', () => {
      this.button.innerHTML = this.Play
    })

    this.button.addEventListener('click', () => this.togglePlayPause())

    this.button.innerHTML = this.video.paused ? this.Play : this.Pause
  }

  async togglePlayPause () {
    if (this.video.paused) {
      try {
        await this.video.play()
      } catch (error) {
        console.warn('Video play failed:', error)
      }
    } else {
      this.video.pause()
    }
  }

  onEntry ([entry], observer) {
    if (!entry.isIntersecting) return

    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)',
    ).matches

    if (prefersReducedMotion) {
      this.video.removeAttribute('autoplay')
      this.video.setAttribute('controls', '')
      this.video.pause()
    }

    if (this.video.dataset?.poster) {
      this.video.setAttribute('poster', this.video.dataset.poster)
    }

    for (const source in this.video.children) {
      const videoSource = this.video.children[source]

      if (
        typeof videoSource.tagName === 'string' &&
        videoSource.tagName === 'SOURCE'
      ) {
        if (videoSource.dataset.src) {
          videoSource.src = videoSource.dataset.src
        }
      }
    }

    this.video.load()
    observer.unobserve(this.video)

    this.setAttribute('loaded', '')

    this.addPlayPauseButton()
  }
}

if (!customElements.get('lazy-video')) {
  customElements.define('lazy-video', LazyVideo)
}
